(function () {
  document.addEventListener('DOMContentLoaded', function () {

    // Gallery thumbnails
    document.querySelectorAll('[data-hs-gallery]').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-hs-thumb]');
      var frames = gallery.querySelectorAll('[data-hs-frame]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.getAttribute('data-index');
          thumbs.forEach(function (t) { t.classList.remove('is-selected'); });
          thumb.classList.add('is-selected');
          frames.forEach(function (f) {
            f.classList.toggle('is-active', f.getAttribute('data-index') === index);
          });
        });
      });
    });

    // Always resolve our own form by ID. Do NOT use buybox.querySelector('form'):
    // Seal Subscriptions injects markup into the same container, and if its
    // markup contains a form that lands first, that lookup returns the wrong
    // form. That silently broke Subscribe — the hidden selling_plan input was
    // never found, so no plan was attached, while the button label changed
    // anyway and made it look like it had worked.
    var mainForm = document.getElementById('hs-pdp-form');
    var atcButton = document.querySelector('[data-hs-atc]');
    var stickyAtc = document.querySelector('[data-hs-sticky-atc]');
    var stickyPriceEl = document.querySelector('[data-hs-sticky-price]');
    var drawer = document.getElementById('hs-atc-drawer');

    // Money formatting — the store sells in CAD as well as USD via Markets, so
    // never hardcode "$" or assume USD.
    var CURRENCY = (drawer && drawer.getAttribute('data-currency')) || 'USD';

    function money(cents) {
      if (typeof cents !== 'number') return '';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: CURRENCY
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + CURRENCY;
      }
    }

    // ---------------------------------------------------------------------
    // Purchase option state
    //
    // selectedSellingPlan is the AUTHORITATIVE record of what the customer
    // chose. It is a plain JS variable on purpose: the hidden input lives in
    // DOM that Seal also writes to, and anything Seal can move, clone or
    // disable cannot be trusted as the source of truth. The hidden input is
    // kept in sync only as a fallback for a native (non-JS) submit.
    // ---------------------------------------------------------------------
    var selectedSellingPlan = null;

    function setCtaLabels(mode) {
      [atcButton, stickyAtc].forEach(function (btn) {
        if (!btn) return;
        var oneTime = btn.getAttribute('data-label-onetime') || 'Add to Cart';
        var subscribe = btn.getAttribute('data-label-subscribe') || 'Subscribe & Save';
        btn.textContent = mode === 'subscribe' ? subscribe : oneTime;
      });
    }

    // ---------------------------------------------------------------------
    // Bundle card prices follow the toggle.
    //
    // Liquid renders both purchase options onto data-* attributes using the
    // `money` filter, so every value is already in the customer's presentment
    // currency. Previously the card always showed the one-time price even with
    // Subscribe selected — the same display-versus-reality gap that caused the
    // original subscription bug.
    //
    // Tiers with no resolvable variant render the fallback strings and carry
    // no data-* attributes, so they are skipped here and left untouched.
    // ---------------------------------------------------------------------
    function setBundlePrices(mode) {
      var sub = mode === 'subscribe';

      // The headline price always shows something: if a tier has no
      // subscription allocation, fall back to its one-time price.
      document.querySelectorAll('.hs-pdp-price-now[data-price-onetime]').forEach(function (node) {
        var value = (sub && node.getAttribute('data-price-subscribe')) || node.getAttribute('data-price-onetime');
        node.textContent = value;
      });

      // Strikethrough, discount badge and per-serving are hidden rather than
      // shown empty when the relevant value does not exist.
      [
        ['.hs-pdp-price-was', 'data-was-onetime', 'data-was-subscribe'],
        ['.hs-pdp-price-off', 'data-off-onetime', 'data-off-subscribe'],
        ['.hs-pdp-per-serving', 'data-ps-onetime', 'data-ps-subscribe']
      ].forEach(function (spec) {
        document.querySelectorAll(spec[0] + '[' + spec[1] + ']').forEach(function (node) {
          var value = sub ? node.getAttribute(spec[2]) : node.getAttribute(spec[1]);
          if (!value) {
            node.textContent = '';
            node.hidden = true;
          } else {
            node.textContent = value;
            node.hidden = false;
          }
        });
      });

      updateStickyPrice();
    }

    // Sticky bar mirrors the selected tier at the selected purchase option,
    // rather than being copied once from the first tier at page load.
    function updateStickyPrice() {
      if (!stickyPriceEl) return;
      var checked = document.querySelector('.hs-pdp-bundle input[type="radio"]:checked');
      var card = checked ? checked.closest('.hs-pdp-bundle') : document.querySelector('.hs-pdp-bundle');
      var priceNode = card ? card.querySelector('.hs-pdp-price-now') : null;
      if (priceNode) stickyPriceEl.textContent = priceNode.textContent;
    }

    // Bundle selection
    document.querySelectorAll('.hs-pdp-bundle input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var group = radio.closest('.hs-pdp-bundles');
        if (group) {
          group.querySelectorAll('.hs-pdp-bundle').forEach(function (card) { card.classList.remove('is-selected'); });
        }
        radio.closest('.hs-pdp-bundle').classList.add('is-selected');
        var input = radio.closest('.hs-pdp-buybox').querySelector('[data-hs-variant-input]');
        if (input && radio.value) {
          input.value = radio.value;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateStickyPrice();
      });
    });
    var initialBundle = document.querySelector('.hs-pdp-bundle input[type="radio"]:checked');
    if (initialBundle) initialBundle.closest('.hs-pdp-bundle').classList.add('is-selected');

    document.querySelectorAll('[data-hs-freq-toggle]').forEach(function (toggle) {
      var planId = toggle.getAttribute('data-selling-plan-id');

      function applyMode(mode) {
        toggle.querySelectorAll('.hs-pdp-freq-option').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        var checked = toggle.querySelector('input[type="radio"]:checked');
        if (checked) checked.closest('.hs-pdp-freq-option').classList.add('is-selected');

        selectedSellingPlan = (mode === 'subscribe' && planId) ? planId : null;

        // Mirror onto the hidden input for the no-JS / native-submit path. A
        // blank-but-enabled selling_plan is read by Shopify as "apply a plan"
        // and resolves to the variant default, so one-time must leave the
        // field DISABLED, not merely empty.
        var hidden = mainForm ? mainForm.querySelector('[data-hs-selling-plan-input]') : null;
        if (hidden) {
          if (selectedSellingPlan) {
            hidden.value = selectedSellingPlan;
            hidden.disabled = false;
          } else {
            hidden.value = '';
            hidden.disabled = true;
          }
        }

        setCtaLabels(mode);
        setBundlePrices(mode);
      }

      toggle.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () { applyMode(radio.value); });
      });

      var initialFreq = toggle.querySelector('input[type="radio"]:checked');
      applyMode(initialFreq ? initialFreq.value : 'onetime');
    });

    // Products with no subscription plan have no toggle, so seed both.
    if (!document.querySelector('[data-hs-freq-toggle]')) {
      setCtaLabels('onetime');
      setBundlePrices('onetime');
    }

    // Neutralize any subscription app's auto-injected purchase-option control.
    // CSS hides Seal's widget but hidden fields still serialize, and a later
    // duplicate named selling_plan would beat ours.
    function disableForeignSellingPlanFields(root) {
      root.querySelectorAll('.hs-pdp-buybox [name="selling_plan"]').forEach(function (node) {
        if (!node.hasAttribute('data-hs-selling-plan-input') && !node.disabled) node.disabled = true;
      });
    }
    disableForeignSellingPlanFields(document);

    var buyboxes = document.querySelectorAll('.hs-pdp-buybox');
    if (buyboxes.length && window.MutationObserver) {
      var watcher = new MutationObserver(function () { disableForeignSellingPlanFields(document); });
      buyboxes.forEach(function (box) { watcher.observe(box, { childList: true, subtree: true }); });
      setTimeout(function () { watcher.disconnect(); }, 10000);
    }

    // Payload built from JS state, never from FormData.
    function buildAddPayload(form) {
      var idEl = form.querySelector('[name="id"]:not([disabled])');
      var qtyEl = form.querySelector('[name="quantity"]:not([disabled])');
      var payload = {
        id: idEl ? idEl.value : null,
        quantity: (qtyEl && parseInt(qtyEl.value, 10)) || 1
      };
      if (selectedSellingPlan) payload.selling_plan = selectedSellingPlan;
      return payload;
    }

    // Error surfacing. Silent fallback to /cart made a rejected selling plan
    // look identical to a successful one-time add — that is how this class of
    // bug hides. Say what went wrong.
    var errorEl = null;
    function showError(message) {
      if (!atcButton) { window.alert(message); return; }
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'hs-pdp-atc-error';
        errorEl.setAttribute('role', 'alert');
        errorEl.style.cssText =
          'margin:10px 0 0;font-size:13px;line-height:1.45;color:var(--hs-red,#E0341F);font-weight:600;';
        atcButton.parentNode.insertBefore(errorEl, atcButton.nextSibling);
      }
      errorEl.textContent = message;
    }
    function clearError() { if (errorEl) errorEl.textContent = ''; }

    // ---------------------------------------------------------------------
    // Confirmation drawer
    // ---------------------------------------------------------------------
    var activeLineKey = null;
    var lastFocused = null;

    function el(sel) { return drawer ? drawer.querySelector(sel) : null; }
    function setBusy(state) { if (drawer) drawer.classList.toggle('is-busy', !!state); }

    function renderLine(item) {
      if (!item) return;
      activeLineKey = item.key || activeLineKey;

      var mediaEl = el('[data-hs-atc-media]');
      if (mediaEl) mediaEl.innerHTML = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '';

      var nameEl = el('[data-hs-atc-name]');
      if (nameEl) nameEl.textContent = item.product_title || item.title || 'Item';

      // Read the purchase option off the cart's own response, never off what
      // the toggle claimed. What the customer sees is what Shopify recorded.
      var allocation = item.selling_plan_allocation;
      var planName = allocation && allocation.selling_plan && allocation.selling_plan.name;
      var planEl = el('[data-hs-atc-plan]');
      if (planEl) {
        if (planName) {
          planEl.textContent = 'Subscription — ' + planName;
          planEl.className = 'hs-atc__plan hs-atc__plan--subscription';
        } else {
          planEl.textContent = 'One-time purchase';
          planEl.className = 'hs-atc__plan hs-atc__plan--onetime';
        }
      }

      var noteEl = el('[data-hs-atc-note]');
      if (noteEl) {
        noteEl.textContent = planName
          ? 'Change the delivery schedule or cancel anytime from your account.'
          : 'No subscription. This is a single order.';
      }

      var qtyEl = el('[data-hs-atc-qty]');
      if (qtyEl) qtyEl.textContent = item.quantity;

      var downBtn = el('[data-hs-atc-qty-down]');
      if (downBtn) downBtn.disabled = item.quantity <= 1;

      var priceEl = el('[data-hs-atc-price]');
      if (priceEl) priceEl.textContent = money(item.final_line_price);
    }

    function renderCart(cart) {
      if (!cart) return;

      var subtotalEl = el('[data-hs-atc-subtotal]');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

      var restEl = el('[data-hs-atc-rest]');
      if (restEl) {
        var others = 0;
        (cart.items || []).forEach(function (line) {
          if (line.key !== activeLineKey) others += line.quantity;
        });
        if (others > 0) {
          restEl.textContent = '+ ' + others + (others === 1 ? ' other item' : ' other items') + ' already in your cart';
          restEl.hidden = false;
        } else {
          restEl.hidden = true;
        }
      }

      document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]')
        .forEach(function (node) { node.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('hs:cart:updated', { detail: cart }));
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); return cart; })
        .catch(function () { /* subtotal is informational — never block on it */ });
    }

    function openDrawer(item) {
      if (!drawer) { window.location.href = '/cart'; return; }
      lastFocused = document.activeElement;
      renderLine(item);
      fetchCart();

      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hs-atc-open');
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var panel = drawer.querySelector('.hs-atc__panel');
        if (panel) panel.focus();
      });
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hs-atc-open');
      setTimeout(function () { drawer.hidden = true; }, 260);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    // Quantity and remove key on the LINE, not the variant: the same variant
    // can sit in the cart twice under different purchase options.
    function changeQuantity(quantity) {
      if (!activeLineKey) return;
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: activeLineKey, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (quantity === 0) { renderCart(cart); closeDrawer(); return; }
          var line = (cart.items || []).filter(function (i) { return i.key === activeLineKey; })[0];
          if (line) renderLine(line);
          renderCart(cart);
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { setBusy(false); });
    }

    if (drawer) {
      drawer.querySelectorAll('[data-hs-atc-close]').forEach(function (node) {
        node.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (!drawer.hidden && e.key === 'Escape') closeDrawer();
      });

      var upBtn = el('[data-hs-atc-qty-up]');
      var downBtn2 = el('[data-hs-atc-qty-down]');
      var removeBtn = el('[data-hs-atc-remove]');
      var qtyReadout = el('[data-hs-atc-qty]');

      function currentQty() { return parseInt(qtyReadout && qtyReadout.textContent, 10) || 1; }

      if (upBtn) upBtn.addEventListener('click', function () { changeQuantity(currentQty() + 1); });
      if (downBtn2) downBtn2.addEventListener('click', function () {
        var next = currentQty() - 1;
        if (next >= 1) changeQuantity(next);
      });
      if (removeBtn) removeBtn.addEventListener('click', function () { changeQuantity(0); });

      // Fallback only. hs-cross-sell-modal.js intercepts [name="checkout"] in
      // the capture phase and stops propagation, so this runs only when that
      // script bailed out early.
      var drawerCheckout = el('[data-hs-atc-checkout]');
      if (drawerCheckout) {
        drawerCheckout.addEventListener('click', function () { window.location.href = '/checkout'; });
      }
    }

    // ---------------------------------------------------------------------
    // Add to cart
    // ---------------------------------------------------------------------
    if (mainForm) {
      mainForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var payload = buildAddPayload(mainForm);
        if (!payload.id) { showError('Please choose an option before adding to cart.'); return; }

        var wantedPlan = payload.selling_plan || null;
        var restore = atcButton ? atcButton.textContent : '';
        if (atcButton) { atcButton.disabled = true; atcButton.textContent = 'Adding…'; }
        if (stickyAtc) stickyAtc.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            var item = res.body;

            if (!res.ok || (item && item.status && item.status >= 400)) {
              throw new Error((item && (item.description || item.message)) || 'Could not add to cart.');
            }

            // Never show "One-time purchase" to someone who asked to subscribe.
            // If the plan did not attach, that is a failure, not a fallback.
            var got = item && item.selling_plan_allocation;
            if (wantedPlan && !got) {
              throw new Error(
                'We could not apply the subscription to this item. Nothing has been charged — ' +
                'please try again or contact us.'
              );
            }

            openDrawer(item);
          })
          .catch(function (err) {
            showError(err && err.message ? err.message : 'Could not add to cart. Please try again.');
          })
          .finally(function () {
            if (atcButton) { atcButton.disabled = false; atcButton.textContent = restore; }
            if (stickyAtc) stickyAtc.disabled = false;
          });
      });
    }

    // Sticky add-to-cart bar
    var hero = document.querySelector('.hs-pdp-hero');
    var stickyBar = document.querySelector('[data-hs-sticky]');
    if (hero && stickyBar) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(hero);

      if (stickyAtc && mainForm) {
        stickyAtc.addEventListener('click', function () {
          mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
        });
      }
    }

    updateStickyPrice();
  });
})();
